import axios from '../axiosConfig'; // Assuming this is your configured Axios instance
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;
const fetchCustomContent = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/custom/info', {
      headers: headers
    });
    console.log(response);
    return response.result;
  } catch (error) {
    console.error('Error fetching protected content:', error);
    return null;
  }
};
const fetchSavedAddressList = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/savedaddress/list', {
      headers: headers
    });
    console.log(response);
    return response.cartList;
  } catch (error) {
    console.error('Error fetching protected content:', error);
    return null;
  }
};

export { fetchCustomContent ,fetchSavedAddressList};